import ROLES from '@/utils/roles';
import TOP_BARS from '@/utils/topBars';
import FOOTERS from '@/utils/footers';
let routes = [
  /**
   * @description 答案之书
   * @function the-book-of-answers 答案之书
   * @param { Component } Test ties/TheBookOfAnswers/Home
   * @param { Name } pathname the-book-of-answers
   */
  {
    path: '/the-book-of-answers',
    name: 'the-book-of-answers',
    meta: {
      title: '答案之书'
    },
    component: () => import('@/views/Activities/TheBookOfAnswers/Home')
  },
  /**
   * @description 答案之书
   * @function the-book-of-answers-land 答案之书
   * @param { Component } Test ties/TheBookOfAnswers/Land
   * @param { Name } pathname the-book-of-answers-land
   */
  {
    path: '/the-book-of-answers/land',
    name: 'the-book-of-answers-land',
    meta: {
      title: '答案之书'
    },
    component: () => import('@/views/Activities/TheBookOfAnswers/Land')
  },
  /**
   * @description 答案之书海报
   * @function the-book-of-answers-poster 答案之书海报
   * @param { Component } Test ties/TheBookOfAnswers/Poster
   * @param { Name } pathname the-book-of-answers-poster
   */
  {
    path: '/the-book-of-answers/poster/:openId/:no',
    name: 'the-book-of-answers-poster',
    meta: {
      title: '答案之书海报'
    },
    component: () => import('@/views/Activities/TheBookOfAnswers/Poster')
  },
  /**
   * @desc 抢课海报生成页
   * @function take-lessons-poster
   * @param { Component } Poster views/Activities/TakeLessons/Poster
   * @param { Name } pathname take-lessons-poster
   */
  {
    path: '/take-lessons/poster',
    name: 'take-lessons-poster',
    meta: {
      title: '海报'
    },
    component: () => import('@/views/Activities/TakeLessons/Poster')
  },
  /**
   * @desc 抢课海报保存页
   * @function take-lessons-poster
   * @param { Component } SavePoster views/Activities/TakeLessons/SavePoster
   * @param { Name } pathname take-lessons-save-poster
   */
  {
    path: '/take-lessons/save-poster',
    name: 'take-lessons-save-poster',
    meta: {
      title: '海报'
    },
    component: () => import('@/views/Activities/TakeLessons/SavePoster')
  },
  /**
   * @desc 抢课助力页
   * @function take-lessons-help
   * @param { Component } Help views/Activities/TakeLessons/Help
   * @param { Name } pathname take-lessons-help
   */
  {
    path: '/take-lessons/help',
    name: 'take-lessons-help',
    meta: {
      title: '抢课助力'
    },
    component: () => import('@/views/Activities/TakeLessons/Help')
  },
  /**
   * @desc 抢课助力页
   * @function take-lessons-help
   * @param { Component } Help views/Activities/TakeLessons/Help
   * @param { Name } pathname take-lessons-help
   */
  {
    path: '/take-lessons/detail',
    name: 'take-lessons-detail',
    meta: {
      title: '抢课助力'
    },
    component: () => import('@/views/Activities/TakeLessons/Detail')
  },
  /**
   * @desc 抢课助力页
   * @function take-lessons-banner
   * @param { Component } Banner views/Activities/TakeLessons/Banner
   * @param { Name } pathname take-lessons-banner
   */
  {
    path: '/take-lessons/banner',
    name: 'take-lessons-banner',
    meta: {
      title: '海报'
    },
    component: () => import('@/views/Activities/TakeLessons/Banner')
  },
  {
    path: '/thousand/:submit?',
    name: 'thousand',
    meta: {
      title: '让1000件好事发生'
    },
    component: () => import('@/views/Activities/Thousand')
  }
];
routes = routes.map(item => {
  let ret = Object.assign({}, item);
  ret.meta = Object.assign({}, ret.meta, {
    role: ROLES.STUDENT,
    topBar: TOP_BARS.NULL,
    footer: FOOTERS.NULL
  });
  return ret;
});
export default routes;
